import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "field is-grouped" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_6 = {
  key: 2,
  class: "help is-danger"
}
const _hoisted_7 = { class: "control" }

import { ConditionViewModel } from '../models/conditionViewModel';
import { ConditionOperationType } from '../models/conditions';
import { required, numeric, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { PropType, ref, onMounted, computed } from 'vue';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'DurationCondition',
  props: {
  condition: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
},
  emits: ["changed", "completed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const liveCondition = ref<ConditionViewModel>({
  attribute: '',
  operation: '',
  type: '',
  value: '',
  result: true,
});

const greaterThanZero = (value: number) => value > 0;
const validations = computed(() => ({
  liveCondition: {
    value: {
      required: requiredIf(() => liveCondition.value.operation !== ConditionOperationType.IsSet),
      minValue: greaterThanZero,
      numeric,
    },
  },
}));

const $v = useVuelidate(validations, { liveCondition });
const isRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.liveCondition.value));
const isNumericInvalid = computed(() => VuelidateUtil.isValidationInvalid($v, (v) => v.liveCondition.value, 'numeric'));
const isMinValueInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.liveCondition.value, 'minValue'),
);

onMounted(() => {
  if (props.condition) {
    liveCondition.value = {
      attribute: props.condition.attribute,
      operation: ConditionOperationType.Equals,
      type: props.condition.type,
      value: props.condition.value,
      result: props.condition.result,
      unit: 'seconds',
      invalid: props.condition.invalid,
    };

    if (liveCondition.value.invalid) {
      $v.value.$touch();
    }
  }
});

function secondsChanged(event: any) {
  liveCondition.value.value = event.target.value;
  $v.value.$touch();
  emitConditionChanged();
}

function emitConditionChanged() {
  liveCondition.value.invalid = $v.value.$invalid;
  emit('changed', liveCondition.value);
}

function complete() {
  liveCondition.value.invalid = $v.value.$invalid;
  emit('completed', liveCondition.value);
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          value: liveCondition.value.value,
          type: "number",
          class: "input",
          onInput: secondsChanged
        }, null, 40, _hoisted_3),
        (isRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Number of seconds required"))
          : (isNumericInvalid.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Must be a valid whole number"))
            : (isMinValueInvalid.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Must be greater than 0"))
              : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "control" }, [
        _createElementVNode("div", { class: "relative-text" }, [
          _createElementVNode("span", null, "seconds")
        ])
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_n_button, {
        variant: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (complete()))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Done", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})